import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useOnboardingSteps from '../hooks/useOnboardingSteps';

/**
 * OnboardingGate wraps protected routes and redirects eligible users
 * to /onboarding if they haven't completed the setup.
 */
export function OnboardingGate({ children }) {
  const location = useLocation();
  const {
    hasHydrated,
    loading,
    isEligible,
    isPublicAuthPath,
    onboardingIsComplete,
    steps,
  } = useOnboardingSteps({
    enabled: true,
    pathname: location.pathname,
    skipPublicAuthRoutes: true,
  });

  const isOnboardingStepPath = steps.some((s) => s.path === location.pathname);
  const bypassGate = isPublicAuthPath || location.pathname === '/onboarding' || isOnboardingStepPath;

  if (!hasHydrated || (isEligible && loading && !bypassGate)) {
    return <div className="flex items-center justify-center min-h-screen bg-slate-50">Loading...</div>;
  }

  if (bypassGate || !isEligible) {
    return children;
  }

  if (!onboardingIsComplete) {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
}

export default OnboardingGate;
